export default `
mutation sendHydrogenLeadsRequest (
  $addressLine1: String
  $addressLine2: String
  $city: String!
  $companyName: String!
  $country: String!
  $countryCode: String!
  $dynamicTitle: String!
  $email: String!
  $lastName: String!
  $firstName: String!
  $leadSubSource: String
  $message: String
  $phone: String!
  $postalCode: String!
  $newsletter: Boolean
  $products: [HydrogenLeadsProductInput]
) {
  sendHydrogenLeadsRequest(
    input: {
      addressLine1: $addressLine1
      addressLine2: $addressLine2
      city: $city
      companyName: $companyName
      country: $country
      countryCode: $countryCode
      dynamicTitle: $dynamicTitle
      email: $email
      lastName: $lastName
      firstName: $firstName
      leadSubSource: $leadSubSource
      message: $message
      phone: $phone
      postalCode: $postalCode
      newsletter: $newsletter
      products: $products
    }
  ) {
    message
    success
  }
}
`;
